export default __webpack_public_path__ + "static/media/LOGO_APP_12.fd5d4ff2.png";